import React from 'react';
import { GlobalOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

export default {
    Renderer: (props) => {
        const data = props.data

        return (
            <div>
                {data.url && (
                    <iframe src={data.url} frameBorder={"no"} style={{width: "100%", height: data.height}}/>
                )}

                {!data.url && (
                    <Alert showIcon type={"warning"} message={t`Veuillez saisir une URL.`}/>
                )}
            </div>
        )

    },
    id: 'iframe',
    title: t`Page incrusté`,
    description: t`Incruster une url de votre choix`,
    icon: <GlobalOutlined/>,
    version: 1,
    allowClickInside: true,
    controls: {
        type: 'autoform',
        schema: {
            properties: {
                url: {
                    type: 'string',
                    uniforms: {
                        required: true,
                        label: t`Url de la page`,
                        placeholder: t`https://...`,
                    }
                },

                height: {
                    type: 'number',
                    uniforms: {
                        required: true,
                        label: t`Hauteur`,
                        placeholder: t`Hauteur`,
                    }
                },
            }
        }
    }
}
